// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3d83N","bigColWidth":"Table_bigColWidth__3gz6C","biggerColWidth":"Table_biggerColWidth__3gWSi","row":"Table_row__1Zk95","col":"Table_col__3rpLy"};